import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { FormOptionListComponent } from './form-option-list.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [FormOptionListComponent],
  exports: [FormOptionListComponent]
})
export class FormOptionListModule {
}
